import { observer } from "mobx-react-lite";
import { useState } from "react";
import { PlusSmIcon } from "@heroicons/react/outline";

import { CustomModelsTable } from "./CustomModelsTable";
import { CustomModelDialogContent } from "./CustomModelDialog";
import { CustomParametersStoreProvider } from "./CustomModelsCreation/CustomParameters/custom-parameters-store";
import { useCustomModelsControls } from "./hooks/useCustomModelsControls";
import { CustomModel } from "./types";

import { Button } from "@/components/ui/button";

export const CustomModelsCreation = observer(
  ({ models, providerName }: { models: CustomModel[]; providerName?: string }) => {
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

    const { onEditModel, onAddModel, onOpenChange, defaultValues, isOpen } =
      useCustomModelsControls({
        setIsConfirmationModalOpen,
      });

    const handleEditModel = (model: CustomModel) => {
      onEditModel(model, false, providerName);
    };

    return (
      <div className="flex h-full flex-col">
        <CustomModelDialogContent
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          setIsConfirmationModalOpen={setIsConfirmationModalOpen}
          isConfirmationModalOpen={isConfirmationModalOpen}
          defaultValues={defaultValues}
        />
        <div className="flex-1 overflow-hidden">
          <CustomModelsTable
            onEditModel={handleEditModel}
            models={models}
            action={
              providerName ? (
                <Button type="button" variant="outline" onClick={() => onAddModel(providerName)}>
                  <PlusSmIcon className="mr-2 h-4 w-4" />
                  Add model
                </Button>
              ) : undefined
            }
          />
        </div>
      </div>
    );
  },
);

export const WrappedCustomModelsCreation = observer(
  ({ models, providerName }: { models: CustomModel[]; providerName?: string }) => (
    <CustomParametersStoreProvider>
      <CustomModelsCreation models={models} providerName={providerName} />
    </CustomParametersStoreProvider>
  ),
);
